<script>
  import { fitsh } from 'fitsh';
  import { Select } from 'wind-svelte';
  import stateStore from './stateStore';
  import valuation from './valuationStore';
  import config from './configStore';
  import createChecker from '../utils/createChecker';

  $: ({ brand, model, year, authorization } = $valuation);

  let items = [];
  let loading = false;

  const fetchChecker = createChecker(async () => {
    if (!brand || !model) {
      items = [];
      return;
    }
    if (!authorization) {
      loading = true;
      return
    };
    if (year && items.length) return;

    loading = true;
    try {
      const response = await fitsh(
        `${API_URL}/brands/${brand.id}/models/${model.id}/years`
      ).get({
        authorization,
      });
      
      items = response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        $valuation.authorization = null;
      } else {
        console.error(error);
        $stateStore.error = 'No fue posible consultar los modelos, verifique su conexión o intente de nuevo mas tarde';
      }
    } finally {
      loading = false;
    }
  });
  $: fetchChecker(brand?.id, model?.id, authorization);

  const resetChecker = createChecker(async () => {
    $valuation.trim = null;
  }, $valuation.year?.id);
  $: resetChecker(year?.id);

  $: minYear = $config.minYearFilter || 0;
  $: filteredItems = items.filter((item) => item.name >= minYear);
</script>

<Select
  {loading}
  fullWidth
  autocomplete
  clearable
  filled
  label="Año"
  disabled={loading}
  options={filteredItems}
  identify={item => item?.id}
  getText={item => item?.name || ''}
  noResultsCopy={$config.noResultsCopy}
  bind:value={$valuation.year}
/>
